import {makeStyles} from "@material-ui/core/styles";

export const useInlineRadioButtonsStyles = makeStyles(() => ({
    radioLabel: {
        display: "flex",
        alignItems: "center",
        marginRight: "1em"
    }
}));
